import { Extension } from '@tiptap/core';

/**
 * Attributs `fontFamily` / `fontSize` sur la marque `textStyle` (inline).
 * @see https://tiptap.dev/docs/editor/extensions/functionality/fontfamily
 */
export const FontFamily = Extension.create({
  name: 'fontFamily',

  addOptions() {
    return { types: ['textStyle'] };
  },

  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          fontFamily: {
            default: null,
            parseHTML: (element) => {
              const raw = element.style.fontFamily;
              if (!raw) return null;
              return raw.replace(/['"]/g, '').split(',')[0].trim() || null;
            },
            renderHTML: (attributes) => {
              if (!attributes.fontFamily) return {};
              return { style: `font-family: ${attributes.fontFamily}, sans-serif` };
            },
          },
        },
      },
    ];
  },

  addCommands() {
    return {
      setFontFamily: (fontFamily) => ({ chain }) => chain()
        .setMark('textStyle', { fontFamily })
        .run(),
      unsetFontFamily: () => ({ chain }) => chain()
        .setMark('textStyle', { fontFamily: null })
        .removeEmptyTextStyle()
        .run(),
    };
  },
});

export const FontSize = Extension.create({
  name: 'fontSize',

  addOptions() {
    return { types: ['textStyle'] };
  },

  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          fontSize: {
            default: null,
            parseHTML: (element) => element.style.fontSize || null,
            renderHTML: (attributes) => {
              if (!attributes.fontSize) return {};
              return { style: `font-size: ${attributes.fontSize}` };
            },
          },
        },
      },
    ];
  },

  addCommands() {
    return {
      setFontSize: (fontSize) => ({ chain }) => chain()
        .setMark('textStyle', { fontSize })
        .run(),
      unsetFontSize: () => ({ chain }) => chain()
        .setMark('textStyle', { fontSize: null })
        .removeEmptyTextStyle()
        .run(),
    };
  },
});
